import { FilterList } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import classNames from "classnames";
import React from "react";
import CheckboxSelector from "../../screens/Schedules/components/CheckboxSelector";
import CloseSvg from "../../assets/svgs/CloseSvg";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";

const FilterSelect = ({
  value,
  handleChange,
  data,
  placeholder,
  isFrequency,
  enableSearch = false,
  enableSort = true,
  variant = "default",
}) => {
  const isLight = variant === "light";
  const [specialityDropdown, setSpecialityDropdown] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");

  const getSortedData = (arr) => {
    return [...arr].sort((a, b) => {
      const aVal = isFrequency ? a?.name?.toLowerCase() : a?.toLowerCase();
      const bVal = isFrequency ? b?.name?.toLowerCase() : b?.toLowerCase();
      if (aVal < bVal) return -1;
      if (aVal > bVal) return 1;
      return 0;
    });
  };

  const filteredData = (enableSort
    ? getSortedData(
        [...data].filter((item) =>
          enableSearch
            ? isFrequency
              ? item?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
              : item?.toLowerCase()?.includes(searchTerm?.toLowerCase())
            : true
        )
      )
    : [...data].filter((item) =>
        enableSearch
          ? isFrequency
            ? item?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
            : item?.toLowerCase()?.includes(searchTerm?.toLowerCase())
          : true
      )
  );

  return (
    <div
      className={classNames(
        "relative flex flex-row items-center gap-2",
        isLight
          ? "min-w-[220px] w-56 rounded-lg border border-gray-300 bg-white shadow-sm h-[42px] divide-x divide-gray-300"
          : "w-1/3 divide-x-[2px] divide-primarygrayborder rounded-md border-[2px] border-primarygrayborder h-10"
      )}
    >
      <div
        className="flex items-center w-full gap-2 overflow-x-scroll no-scrollbar"
        onClick={() => setSpecialityDropdown(!specialityDropdown)}
      >
        <div className="ml-2 min-w-fit">
          <Tooltip title="Filter">
            <button
              className={classNames(
                "rounded-full w-7 h-7",
                value.length > 0
                  ? isLight
                    ? "bg-blue-600"
                    : "bg-primaryblue"
                  : isLight
                    ? "bg-gray-300"
                    : "bg-primarygrayborder"
              )}
            >
              <FilterList
                style={{
                  color: "#FFF",
                  fontSize: "20px",
                }}
              />
            </button>
          </Tooltip>
        </div>
        <div className="flex flex-row items-center h-full gap-2 px-2 overflow-scroll cursor-grab flex-nowrap no-scrollbar">
          {value.length === 0 && (
            <p
              className={classNames(
                "m-0 text-base whitespace-nowrap px-2 py-[2px]",
                isLight ? "text-gray-400" : "text-primarygrayborder"
              )}
            >
              {placeholder}
            </p>
          )}
          {value.map((speciality, index) => (
            <div
              key={index}
              className={classNames(
                "flex flex-row gap-2 items-center px-2 py-[2px] m-0 text-base text-white rounded-full",
                isLight ? "bg-blue-600" : "bg-primaryblue"
              )}
            >
              <p aria-multiline={false} className="m-0 whitespace-nowrap">
                {isFrequency
                  ? data?.find((item) => item?.value == speciality)?.name
                  : speciality}
              </p>
              <Tooltip title="Remove">
                <button
                  onClick={() => handleChange(speciality)}
                  className="flex items-center justify-center scale-90 border border-white rounded-full aspect-square"
                >
                  <CloseSvg color={"#FFF"} />
                </button>
              </Tooltip>
            </div>
          ))}
        </div>
      </div>
      {specialityDropdown && data.length > 0 && (
        <ClickAwayListener
          onClickAway={() => {
            setSpecialityDropdown(false);
            if (enableSearch) setSearchTerm("");
          }}
        >
          <div className="absolute z-50 flex flex-col w-full overflow-auto bg-white border rounded-md max-h-52 top-14 speciality-dropdown">
            {enableSearch && (
              <div className="relative w-full px-3 py-2 border-b">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pr-8 text-sm outline-none"
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm("")}
                    className="absolute text-sm transform -translate-y-1/2 right-4 top-1/2 text-primarygray hover:text-primaryblue"
                  >
                    &#x2715;
                  </button>
                )}
              </div>
            )}

            {filteredData
              .map((speciality, index) => (
              <div
                className={classNames(
                  "hover:bg-primarylightgrey",
                  index !== data.length - 1 && "border-b"
                )}
              >
                <CheckboxSelector
                  key={index}
                  header={isFrequency ? speciality?.name : speciality}
                  isChecked={
                    value.indexOf(
                      isFrequency ? speciality?.value : speciality
                    ) !== -1
                  }
                  handleChange={(_e) =>
                    handleChange(isFrequency ? speciality?.value : speciality)
                  }
                  isBold={false}
                />
              </div>
            ))}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default FilterSelect;
